var _rect, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPaypal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 40,
    viewBox: "0 0 68 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 67,
    height: 39,
    rx: 5.5,
    stroke: "#6F767E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.8083 13.2675C45.8625 12.8272 45.8908 12.3789 45.8908 11.9239C45.8908 8.1 42.7908 5 38.9669 5H27.3955C26.6676 5 26.0462 5.52562 25.9254 6.24337L21.6617 31.5856C21.5087 32.4949 22.2097 33.3236 23.1317 33.3236H27.3637C28.0915 33.3236 28.7247 32.7984 28.8453 32.0806C28.8453 32.0806 28.8524 32.0385 28.8652 31.9627H28.8652L28.2755 35.4681C28.1407 36.2696 28.7585 37 29.5712 37H33.2735C33.9151 37 34.4628 36.5367 34.5692 35.9041L35.621 29.6528C35.8024 28.5752 36.7353 27.7861 37.828 27.7861H38.8006C44.0837 27.7861 48.3665 23.5033 48.3665 18.2203C48.3665 16.1759 47.356 14.3689 45.8083 13.2675Z",
    fill: "#002987"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45.8013 13.2656C45.1392 18.6518 40.5485 22.8225 34.9834 22.8225H31.7543C31.0255 22.8225 30.3961 23.3079 30.1987 23.9943L28.2685 35.4661C28.1337 36.2676 28.7515 36.9981 29.5642 36.9981H33.2665C33.9081 36.9981 34.4558 36.5348 34.5622 35.9022L35.614 29.6509C35.7953 28.5733 36.7283 27.7843 37.821 27.7843H38.7936C44.0767 27.7843 48.3595 23.5014 48.3595 18.2184C48.3595 16.1741 47.349 14.367 45.8013 13.2656Z",
    fill: "#0085CC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7589 22.825H34.9879C40.5531 22.825 45.1438 18.6543 45.8058 13.2682C44.8128 12.5615 43.5993 12.1445 42.2877 12.1445H33.8596C32.9 12.1445 32.0807 12.8375 31.9214 13.7837L30.2031 23.9967C30.4006 23.3103 31.0301 22.825 31.7589 22.825Z",
    fill: "#00186A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaypal);
export default __webpack_public_path__ + "static/media/paypal.ddd5e405ed6b82e21d42dcfd2c1cd5a4.svg";
export { ForwardRef as ReactComponent };